/**
 * WebMCP ships as a Chrome origin trial, so the feature only exists on a page that presents a
 * token registered for its origin. Chrome accepts the token either as this meta tag or as an
 * `Origin-Trial` response header; the meta tag is used here because the token is per-origin and
 * the head is already where the other per-document signals live.
 *
 * It must be `http-equiv`, not `name` — Chrome ignores an `origin-trial` meta tag spelled with
 * `name`, silently, with no console warning to hint at it.
 *
 * Two request-level requirements come with the trial: the document must stay origin-isolated
 * (never send `Origin-Agent-Cluster: ?0`), and the `tools` permission policy must allow the
 * document — it defaults to `self`, which is what we want.
 */
export const WEBMCP_ORIGIN_TRIAL_HTTP_EQUIV = 'origin-trial';

/**
 * The registered token for `https://hotpads.com`.
 *
 * Committed rather than configured because it is public by design — it renders into the head of
 * every page — and because it is cryptographically pinned to that one origin, so it is inert
 * anywhere else. That keeps production working on merge with no deploy-config step.
 *
 * Registered for the **exact** origin, with no subdomain match, so it does nothing on
 * `www.hotpads.com` or any other subdomain. It also does nothing on Sherman previews
 * (`*.testpads.net`) — use `chrome://flags/#enable-webmcp-testing` to QA there.
 *
 * Decoded payload: `{"origin":"https://hotpads.com:443","feature":"WebMCP","expiry":1794873600}`
 * — the trial ends with Chrome 156 on 2026-11-17, after which this token stops validating and
 * the tools go dark on their own. `WEBMCP_ORIGIN_TRIAL_TOKEN` overrides it without a code change.
 */
const REGISTERED_TOKEN =
  'Au8Z3Mpgzloau2Ck83LldaY9RtmnfgEpfOVBneJwJeSNobzf3AGCq11iFLbaAgYNpqWT1NBhJ875WkBjNPOQPgEAAABLeyJvcmlnaW4iOiJodHRwczovL2hvdHBhZHMuY29tOjQ0MyIsImZlYXR1cmUiOiJXZWJNQ1AiLCJleHBpcnkiOjE3OTQ4NzM2MDB9';

export function getWebMcpOriginTrialToken(): string {
  return process.env.WEBMCP_ORIGIN_TRIAL_TOKEN || REGISTERED_TOKEN;
}
